import React from 'react';
import badgeNotificationStyles from './BadgeNotification.scss';
const BadgeNotificationIcon = ({ name , imgSrc  })=>/*#__PURE__*/ React.createElement("div", {
        className: badgeNotificationStyles['icon-wrap']
    }, /*#__PURE__*/ React.createElement("img", {
        loading: "lazy",
        alt: name,
        className: badgeNotificationStyles['icon'],
        src: imgSrc
    }));
BadgeNotificationIcon.displayName = 'BadgeNotificationIcon';
export default BadgeNotificationIcon;
